import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { UploadedFile } from 'web-library/models/UploadedFile';
import {
  UploadedFileModel,
  useGetUploadedFileInfo,
} from '../../../api-refactored/special-consideration/useGetUploadedFileInfo';
import UploadSupportingDocumentsContent from '../../groupSpecialConsideration/UploadSupportingDocuments/UploadSupportingDocumentsContent';

interface UploadSupportingDocumentsProps {
  routeSteps: { label: string }[];
  amendment: boolean;
}

const UploadSupportingDocuments = ({ routeSteps, amendment }: UploadSupportingDocumentsProps) => {
  const { uuid } = useParams<{ uuid: string }>();
  const [files, setFiles] = useState<UploadedFile[]>([]);
  const [draftFiles, setDraftFiles] = useState<UploadedFile[]>([]);
  const [isFileLoaded, setIsFileLoaded] = useState(false);

  const { data: uploadedFileInfo } = useGetUploadedFileInfo({
    uuid,
    onSuccess: (data) => {
      const attachFiles = data
        .filter((item: UploadedFileModel) => !item.isSubmitted)
        .map((f) => {
          const newFile = new File([new ArrayBuffer(f.fileSizeInBytes)], f.fileName);
          return {
            file: newFile,
            hasError: false,
            pending: false,
            uploaded: true,
            key: f.fileUuid,
          };
        });
      setDraftFiles(attachFiles);
      setIsFileLoaded(true);
    },
  });

  return (
    <>
      {isFileLoaded && (
        <UploadSupportingDocumentsContent
          routeSteps={routeSteps}
          uploadedFileInfo={uploadedFileInfo}
          files={files}
          draftFiles={draftFiles}
          setFiles={setFiles}
          setDraftFiles={setDraftFiles}
          isGroup={false}
          amendment={amendment}
        />
      )}
    </>
  );
};

export default UploadSupportingDocuments;
